import { ImsCostingMethod } from "@redotech/crdb-enums/inventory/ims-costing-method";
import * as z from "zod";

export const CostLedgerState = z.enum([
  "on",
  "building",
  "ready",
  "needsSourceOfTruth",
]);
export type CostLedgerState = z.infer<typeof CostLedgerState>;

export const getCostLedgerStatus = {
  name: "getCostLedgerStatus" as const,
  input: z.object({
    /** Asks Temporal whether a build is running; only the cost pages need it. */
    checkBuild: z.boolean().optional(),
  }),
  output: z.object({
    method: z
      .enum([ImsCostingMethod.WeightedAverage, ImsCostingMethod.Fifo])
      .nullable(),
    /** Optional until every server returns it. */
    setup: CostLedgerState.optional(),
  }),
};
